module.exports = __webpack_public_path__ + "static/media/movie.0051f439.svg";